<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pv"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/umaCAPUTI0007#pref">Preface</a></p>
<p class="tocf"><a class="xref" href="#/umaCAPUTI0009#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/umaCAPUTI0010#ch01">C<span class="sm">HAPTER</span> <span class="sm">1</span>	The Road to Fallujah</a></p>
<p class="toc1"><a class="xref" href="#/umaCAPUTI0011#ch02">P<span class="sm">EOPLE'S</span> S<span class="sm">TORIES,</span> P<span class="sm">ART</span> I <i>collected by Asmaa Khalaf Madlool</i></a></p>
<p class="toc"><a class="xref" href="#/umaCAPUTI0012#ch03">C<span class="sm">HAPTER</span> <span class="sm">2</span>	Conflicting Narratives</a></p>
<p class="toc1"><a class="xref" href="#/umaCAPUTI0013#ch04">P<span class="sm">EOPLE'S</span> S<span class="sm">TORIES,</span> P<span class="sm">ART</span> II <i>collected by Asmaa Khalaf Madlool</i></a></p>
<p class="toc"><a class="xref" href="#/umaCAPUTI0014#ch05">C<span class="sm">HAPTER</span> <span class="sm">3</span> 	The First Siege of Fallujah</a></p>
<p class="toc1"><a class="xref" href="#/umaCAPUTI0015#pt01">S<span class="sm">AMI,</span> P<span class="sm">ART</span> I <i>by Kali Rubaii</i></a></p>
<p class="toc"><a class="xref" href="#/umaCAPUTI0016#ch06">C<span class="sm">HAPTER</span> <span class="sm">4</span>	The Intersiege Information Campaign</a></p>
<p class="toc1"><a class="xref" href="#/umaCAPUTI0017#ch07">P<span class="sm">EOPLE'S</span> S<span class="sm">TORIES,</span> P<span class="sm">ART</span> III <i>collected by Asmaa Khalaf Madlool </i></a></p>
<p class="toc"><a class="xref" href="#/umaCAPUTI0018#ch08">C<span class="sm">HAPTER</span> <span class="sm">5</span>	The Second Siege of Fallujah</a></p>
<p class="toc1"><a class="xref" href="#/umaCAPUTI0019#ch09">W<span class="sm">AR</span> H<span class="sm">EROES</span> <span class="sm">AND</span> W<span class="sm">AR</span> C<span class="sm">RIMINALS</span> <i>by Ross Caputi</i></a></p>
<p class="toc"><a class="xref" href="#/umaCAPUTI0020#ch10">C<span class="sm">HAPTER</span> <span class="sm">6</span>	Aftermath</a></p>
<p class="toc1"><a class="xref" href="#/umaCAPUTI0021#ch11">T<span class="sm">HE</span> C<span class="sm">HILDREN</span> <span class="sm">OF</span> F<span class="sm">ALLUJAH</span> <i>by Donna Mulhearn</i></a></p>
<p class="toc"><a class="xref" href="#/umaCAPUTI0022#ch12">C<span class="sm">HAPTER</span> <span class="sm">7</span>	 The Third Siege of Fallujah</a></p>
<p class="toc1"><a class="xref" href="#/umaCAPUTI0023#pt02">S<span class="sm">AMI,</span> P<span class="sm">ART</span> II <i>by Kali Rubaii</i></a></p>
<p class="toc"><a class="xref" href="#/umaCAPUTI0024#conc">Conclusion</a></p>
<p class="toc"><a class="xref" href="#/umaCAPUTI0025#aft">A<span class="sm">FTERWORD</span>	Fallujah</a></p>
<p class="toc1"><i>My Lost Country by Feurat Alani</i></p>
<p class="toc2">translated by Siobhan Marie Meï</p>
<p class="tocbmf"><a class="xref" href="#/umaCAPUTI0026#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/umaCAPUTI0027#index">Index</a></p>
<p class="tocbm"><a class="xref" href="#/umaCAPUTI0029#gallery">Gallery</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// uma-CAPUTI-0006.vue?85a5c00c